import type { ReactNode } from 'react';

/** A numbered section of the Privacy Policy or Terms of Service. */
export function PolicySection({ n, title, children }: { n: number; title: string; children: ReactNode }) {
  const id = `s${n}`;
  return (
    <section className="policy-section" aria-labelledby={id}>
      <h2 id={id}><span className="policy-num">{n}.</span> {title}</h2>
      {children}
    </section>
  );
}
